export enum UploadPurposeEnum {
  AuthorPhoto = 1,
  FrontCover = 2,
  BackCover = 3,
  CoverForPrintPdf = 4,
  BookForPrintPdf = 5,
  BookForEbookPdf = 6,
  VideoThumbnail = 7,
  VideoFile = 8
}
